// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/product_discovery/topups/firstparty/v3/get_onboarding_topup_gate.proto

/* oxlint-disable */

/** Request message for GetOnboardingTopupGate. */
export interface ApiGetOnboardingTopupGateRequest {
  /** Unique identifier of the organization. */
  readonly id: string;
}

/** Response message for GetOnboardingTopupGate. */
export interface ApiGetOnboardingTopupGateResponse {
  /**
   * The calculated target segment of the organization. If target segment is
   * "default", the topup gate should not be applied.
   */
  readonly targetSegment: string;
}

export const ApiGetOnboardingTopupGateRequest: MessageFns<ApiGetOnboardingTopupGateRequest> = {
  fromJSON(object: any): ApiGetOnboardingTopupGateRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetOnboardingTopupGateRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetOnboardingTopupGateResponse: MessageFns<ApiGetOnboardingTopupGateResponse> = {
  fromJSON(object: any): ApiGetOnboardingTopupGateResponse {
    return { targetSegment: isSet(object.target_segment) ? globalThis.String(object.target_segment) : "" };
  },

  toJSON(message: ApiGetOnboardingTopupGateResponse): unknown {
    const obj: any = {};
    if (message.targetSegment !== undefined && message.targetSegment !== null) {
      obj.target_segment = message.targetSegment;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
